<template>
    <div style="display: inline-block;">
        <!-- <b-dropdown right variant="itg" class="ml-2">
      <template v-slot:button-content>
        {{ sortOrderOption ? sortOrderOption.label : '' }}
        <i class="mdi mdi-chevron-down"></i>
      </template>
      <b-dropdown-item @click.prevent="setSortOrder(option)"
                       v-for="(option, i) in sortOrderOptions" :key="i">{{ option.label }}
      </b-dropdown-item>
    </b-dropdown> -->

        <!-- Status -->
        <b-dropdown right variant="itg" class="mr-2">
            <template v-slot:button-content>
                Status: {{ statusDropdownLabel }}
                <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item @click.prevent="toggleStatus(option.value)" v-for="(option, i) in ticketStatusDropdownOptions"
                :key="i">
                {{ option.label }}

                <i v-if="isStatusSelected(option.value)" class="mdi mdi-check ml-1 font-weight-bold"></i>
                <!-- <i v-if="isStatusSelected(option.value)" class="mdi mdi-check-circle ml-1 font-weight-bold"></i> -->
            </b-dropdown-item>
        </b-dropdown>
        <!-- / Status -->

        <!-- Priority -->
        <b-dropdown right variant="itg" class="mr-2">
            <template v-slot:button-content>
                Priority: {{ priorityDropdownLabel }}
                <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item @click.prevent="togglePriority(option.value)"
                v-for="(option, i) in ticketPriorityDropdownOptions" :key="i">
                {{ option.label }}

                <i v-if="isPrioritySelected(option.value)" class="mdi mdi-check ml-1 font-weight-bold"></i>
                <!-- <i v-if="isPrioritySelected(option.value)" class="mdi mdi-check-circle ml-1 font-weight-bold"></i> -->
            </b-dropdown-item>
        </b-dropdown>
        <!-- / Priority -->

        <!-- Difficulty -->
        <b-dropdown right variant="itg" class="mr-2">
            <template v-slot:button-content>
                Difficulty: {{ difficultyDropdownLabel }}
                <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item @click.prevent="toggleDifficulty(option.value)"
                v-for="(option, i) in ticketDifficultyDropdownOptions" :key="i">
                {{ option.label }}

                <i v-if="isDifficultySelected(option.value)" class="mdi mdi-check ml-1 font-weight-bold"></i>
                <!-- <i v-if="isDifficultySelected(option.value)" class="mdi mdi-check-circle ml-1 font-weight-bold"></i> -->
            </b-dropdown-item>
        </b-dropdown>
        <!-- / Difficulty -->
    </div>
</template>

<script>
import Tickets from '../../../../../mixins/Tickets';
export default {
    props: ['filters'],
    mixins: [Tickets],

    methods: {
        isStatusSelected(status) {
            return this.filters.status.includes(status);
        },

        toggleStatus(status) {
            if (this.isStatusSelected(status)) {
                this.filters.status = this.filters.status.filter(s => s !== status);
            } else {
                this.filters.status.push(status);
            }
        },

        isPrioritySelected(priority) {
            return this.filters.priority.includes(priority);
        },

        togglePriority(priority) {
            if (this.isPrioritySelected(priority)) {
                this.filters.priority = this.filters.priority.filter(p => p !== priority);
            } else {
                this.filters.priority.push(priority);
            }
        },

        isDifficultySelected(difficulty) {
            return this.filters.difficulty.includes(difficulty);
        },

        toggleDifficulty(difficulty) {
            if (this.isDifficultySelected(difficulty)) {
                this.filters.difficulty = this.filters.difficulty.filter(d => d !== difficulty);
            } else {
                this.filters.difficulty.push(difficulty);
            }
        }
    },

    computed: {
        statusDropdownLabel() {
            if (this.filters.status.length) {
                let labels = this.filters.status.map(status => {
                    let option = this.ticketStatusDropdownOptions.find(o => o.value === status);
                    return option.label;
                });

                return labels.join(', ');
            }

            return 'All - Not Closed'
        },

        priorityDropdownLabel() {
            if (this.filters.priority.length) {
                let labels = this.filters.priority.map(priority => {
                    let option = this.ticketPriorityDropdownOptions.find(o => o.value === priority);
                    return option.label;
                });

                return labels.join(', ');
            }

            return 'All'
        },

        difficultyDropdownLabel() {
            if (this.filters.difficulty.length) {
                let labels = this.filters.difficulty.map(difficulty => {
                    let option = this.ticketDifficultyDropdownOptions.find(o => o.value === difficulty);
                    return option.label;
                });

                return labels.join(', ');
            }

            return 'All'
        }
    }
}
</script>

<style></style>